export default __webpack_public_path__ + "static/nobell-2e7879a797adc90d046e3491dd36cd82.jpg";